<script>
import ElTabs from 'element-ui/packages/tabs/src/tabs';

export default {
  name: 'WToolTabs',
  mixins: [ElTabs],
  // updated() {
  // },
  mounted() {
    this.$nextTick(function() {
      this.$refs.nav.$children[0].$forceUpdate(); // TODO: TabBar의 barStyle computed는 정상적으로 width가 계산되어 반영되나 변경된 computed 기준으로 update가 발생하지 않음.
    });
  },
  render(h) {
    let { type, handleTabClick, handleTabRemove, handleTabAdd, currentName, panes, editable, addable, tabPosition } = this;

    const newButton =
      editable || addable ? (
        <span
          class="el-tabs__new-tab"
          on-click={handleTabAdd}
          tabindex="0"
          on-keydown={(ev) => {
            if (ev.keyCode === 13) {
              handleTabAdd();
            }
          }}
        >
          <i class="el-icon-plus" />
        </span>
      ) : null;

    const tool = this.$slots.tool ? <div class="el-tabs__tool">{this.$slots.tool}</div> : null;
    const navData = {
      props: {
        currentName,
        onTabClick: handleTabClick,
        onTabRemove: handleTabRemove,
        editable,
        type,
        panes,
      },
      ref: 'nav',
    };
    const header = (
      <div class={['el-tabs__header', `is-${tabPosition}`]}>
        {newButton}
        {tool}
        <tab-nav {...navData} />
      </div>
    );
    const panels = <div class="el-tabs__content">{this.$slots.default}</div>;

    return (
      <div
        class={{
          'el-tabs': true,
          'el-tabs--card': type === 'card',
          [`el-tabs--${tabPosition}`]: true,
          'el-tabs--border-card': type === 'border-card',
        }}
      >
        {tabPosition !== 'bottom' ? [header, panels] : [panels, header]}
      </div>
    );
  },
};
</script>

<style>
.el-tabs__header .el-tabs__tool .el-button--mini {
  line-height: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tabs/ToolTabs/ToolTabs.vue